import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { IonicStorageModule } from "@ionic/storage";
import { Network } from '@ionic-native/network';

import { AppComponent } from './app.component';
import { ComponentsModule } from '../components/components.module';
import { HomePageModule } from '../pages/home/home.module';
import { LangPageModule } from '../pages/lang/lang.module';
import { EditorPageModule } from '../pages/editor/editor.module';
import { LayoutPageModule } from '../pages/layout/layout.module';
import { ModelsPageModule } from '../pages/models/models.module';

// import { File } from '@ionic-native/file';
// import { Transfer } from '@ionic-native/transfer';
// import { FilePath } from '@ionic-native/file-path';
import { Base64ToGallery } from '@ionic-native/base64-to-gallery';
import { Camera } from '@ionic-native/camera';
import { ImportProvider } from '../providers/import/import';
import { MockupProvider } from '../providers/mockup/mockup';

// import { PipesModule } from '../pipes/pipes.module';


import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ModelsProvider } from '../providers/models/models';
import { LayoutsProvider } from '../providers/layouts/layouts';
import { StorageProvider } from '../providers/storage/storage';
import { ResolutionsProvider } from '../providers/resolutions/resolutions';
import { SizesProvider } from '../providers/sizes/sizes';
import { BackgroundsProvider } from '../providers/backgrounds/backgrounds';
import { NetworkProvider } from '../providers/network/network';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpModule,
    IonicModule.forRoot(AppComponent),
    IonicStorageModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    ComponentsModule,
    LangPageModule,
    HomePageModule,
    EditorPageModule,
    LayoutPageModule,
    ModelsPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    AppComponent
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Base64ToGallery,
    AndroidPermissions,
    Camera,
    Network,
    NetworkProvider,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ImportProvider,
    MockupProvider,
    StorageProvider,
    ModelsProvider,
    LayoutsProvider,
    ResolutionsProvider,
    SizesProvider,
    BackgroundsProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts